import React from "react";
import { TrialBalanceResponse } from "../../../common/contracts/accounting-reports";
import { TrialBalanceTableHeader } from "./TrialBalanceTableHeader";
import { TrialBalanceTableBody } from "./TrialBalanceTableBody";

interface Props {
    data: TrialBalanceResponse;
}

export const TrialBalanceTable: React.FC<Props> = ({ data }) => (
    <table className="data-table__table data-table__table--fixed-layout">
        <TrialBalanceTableHeader data={data} />
        <TrialBalanceTableBody data={data} />
    </table>
);
